export default __webpack_public_path__ + "static/media/16.b2032db2.png";